module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (126).c8804ef9.jpg";